import React from 'react'
import { Switch } from 'react-router-dom'
import LoadableRoute from '../components/features/share/loadable/loadableRoute'
import { PrivateRoute, PublicRoute, NPIPrivateRoute, AdminPrivateRoute } from './routePermission'

//Layout
const LayoutMaster = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutMaster'),
})
const LayoutBlank = LoadableRoute({
    loader: () => import('../components/layout/controllers/layoutBlank'),
})

// const LayoutWithHeader = LoadableRoute({
//     loader: () => import('../components/layout/controllers/layoutWithHeader'),
// })

//Features
//Auth
const Login = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/loginController'),
})
const NotFoundController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/NotFoundController'),
})
const UnAuthenController = LoadableRoute({
    loader: () => import('../components/features/auth/controllers/UnAuthenController'),
})

// Home
const HomeController = LoadableRoute({
    loader: () => import('../components/features/home/controllers/homeController'),
})

const CreateReportController = LoadableRoute({
    loader: () => import('../components/features/item/controllers/createReportController'),
})

const CreateDrawingController = LoadableRoute({
    loader: () => import('../components/features/drawing/controllers/createDrawingController'),
})

const CreateItemsController = LoadableRoute({
    loader: () => import('../components/features/drawing/controllers/createItemsController'),
})

const CreateItem2Controller = LoadableRoute({
    loader: () => import('../components/features/item2/controllers/createReportController'),
})

const ExportReportController = LoadableRoute({
    loader: () => import('../components/features/item/controllers/exportReportController'),
})

const SearchDrawingController = LoadableRoute({
    loader: () => import('../components/features/search/controllers/SearchDrawing'),
})

const ViewDrawingController = LoadableRoute({
    loader: () => import('../components/features/viewDrawing/controllers/viewDrawingItemController'),
})

const ViewItem2Controller = LoadableRoute({
    loader: () => import('../components/features/viewDrawing/controllers/viewDrawingItemController'),
})

const CreateSellOrderController = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/coilOrder/controllers/createSellOrderController'),
})

const UpdateSellOrderController = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/coilOrder/controllers/updateSellOrderController'),
})

const ViewSellOrderController = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/coilOrder/controllers/viewSellOrderController'),
})

const SearchSellOrderController = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/coilOrder/controllers/searchSellOrderController'),
})

const ViewReqSearchSellOrderController = LoadableRoute({
    loader: () => import('../components/features/viewRequestDrawing/coilOrder/controllers/searchSellOrderController'),
})

const ViewReqCreateSellOrderController = LoadableRoute({
    loader: () => import('../components/features/viewRequestDrawing/coilOrder/controllers/createSellOrderController'),
})

const ViewReqViewSellOrderController = LoadableRoute({
    loader: () => import('../components/features/viewRequestDrawing/coilOrder/controllers/viewSellOrderController'),
})

const ViewReqUpdateSellOrderController = LoadableRoute({
    loader: () => import('../components/features/viewRequestDrawing/coilOrder/controllers/updateSellOrderController'),
})

// const ListSellOrderController = LoadableRoute({
// loader: () => import('../components/features/reqDrawing/coilOrder/controllers/listSellOrderController'),
//     loader: () => import('../components/features/reqDrawing/coilOrder/controllers/searchSellOrderController'),
// })

// const OverviewControler = LoadableRoute({
//     loader: () => import('../components/features/report/controllers/overviewController'),
// })

const OverviewSellOrderControler = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/coilOrder/controllers/overviewSellOrderController'),
})

const ReStatusReqDrawingController = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/restatus/controllers/reStatusReqDrawingController'),
})

const SystenInfoView = LoadableRoute({
    loader: () => import('../components/features/share/systemInfo'),
    // loader: () => import('../components/features/info/controllers/infoController'),
})
const ViewMasterHome = LoadableRoute({
    loader: () => import('../components/features/masterData/views/viewMasterHome'),
})

const ViewMasterCoatingList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/coating/coatingListController'),
})
const ViewMasterCoatingCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/coating/coatingCreateController'),
})
// const ViewMasterCoatingView = LoadableRoute({
//     loader: () => import('../components/features/masterData/controllers/coating/coatingViewController'),
// })
const ViewMasterCoatingUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/coating/coatingUpdateController'),
})

const ViewMasterFinEdgeList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finEdge/finEdgeListController'),
})
const ViewMasterFinEdgeCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finEdge/finEdgeCreateController'),
})
const ViewMasterFinEdgeView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finEdge/finEdgeViewController'),
})
const ViewMasterFinEdgeUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finEdge/finEdgeUpdateController'),
})

const ViewMasterFinMaterialList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finMaterial/finMaterialListController'),
})
const ViewMasterFinMaterialCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finMaterial/finMaterialCreateController'),
})
const ViewMasterFinMaterialView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finMaterial/finMaterialViewController'),
})

const ViewMasterFinMaterialUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finMaterial/finMaterialUpdateController'),
})

const ViewMasterFinSurfaceList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finFinSurface/finSurfaceListController'),
})
const ViewMasterFinSurfaceCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finFinSurface/finSurfaceCreateController'),
})
const ViewMasterFinSurfaceView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finFinSurface/finSurfaceViewController'),
})

const ViewMasterFinSurfaceUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/finFinSurface/finSurfaceUpdateController'),
})

const ViewMasterTubeSizeList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSize/tubeSizeListController'),
})
const ViewMasterTubeSizeCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSize/tubeSizeCreateController'),
})
const ViewMasterTubeSizeView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSize/tubeSizeViewController'),
})
const ViewMasterTubeSizeUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSize/tubeSizeUpdateController'),
})
const ViewMasterInsideShapeList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/insideShape/insideShapeListController'),
})
const ViewMasterInsideShapeCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/insideShape/insideShapeCreateController'),
})
const ViewMasterInsideShapeView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/insideShape/insideShapeViewController'),
})
const ViewMasterInsideShapeUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/insideShape/insideShapeUpdateController'),
})
const ViewMasterTubeMaterialList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeMaterial/tubeMaterialListController'),
})
const ViewMasterTubeMaterialCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeMaterial/tubeMaterialCreateController'),
})
const ViewMasterTubeMaterialView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeMaterial/tubeMaterialViewController'),
})
const ViewMasterTubeMaterialUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeMaterial/tubeMaterialUpdateController'),
})
const ViewMasterPlateMaterialList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/plateMaterial/plateMaterialListController'),
})
const ViewMasterPlateMaterialCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/plateMaterial/plateMaterialCreateController'),
})
const ViewMasterPlateMaterialView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/plateMaterial/plateMaterialViewController'),
})
const ViewMasterPlateMaterialUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/plateMaterial/plateMaterialUpdateController'),
})
const ViewMasterTubePatternList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubePattern/tubePatternListController'),
})
const ViewMasterTubePatternCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubePattern/tubePatternCreateController'),
})
const ViewMasterTubePatternView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubePattern/tubePatternViewController'),
})
const ViewMasterTubePatternUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubePattern/tubePatternUpdateController'),
})
const ViewMasterTubeSizeAndPatternList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSizeAndPattern/tubeSizeAndPatternListController'),
})
const ViewMasterTubeSizeAndPatternCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSizeAndPattern/tubeSizeAndPatternCreateController'),
})
const ViewMasterTubeSizeAndPatternView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSizeAndPattern/tubeSizeAndPatternViewController'),
})
const ViewMasterTubeSizeAndPatternUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/tubeSizeAndPattern/tubeSizeAndPatternUpdateController'),
})
const ViewMasterProductGroupList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/productGroup/productGroupListController'),
})
const ViewMasterProductGroupCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/productGroup/productGroupCreateController'),
})
const ViewMasterProductGroupView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/productGroup/productGroupViewController'),
})
const ViewMasterProductGroupUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/productGroup/productGroupUpdateController'),
})
const ViewMasterPaintLocationList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/paintLocation/paintLocationListController'),
})
const ViewMasterPaintLocationCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/paintLocation/paintLocationCreateController'),
})
const ViewMasterPaintLocationView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/paintLocation/paintLocationViewController'),
})
const ViewMasterPaintLocationUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/paintLocation/paintLocationUpdateController'),
})

const ViewSetting = LoadableRoute({
    loader: () => import('../components/features/setting/views/viewSettingsHome'),
})

const ViewSystemInfoSetting = LoadableRoute({
    loader: () => import('../components/features/setting/controllers/systemSettingsController'),
})




const ViewMasterCoilTypeList = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/coilType/coilTypeListController'),
})
const ViewMasterCoilTypeCreate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/coilType/coilTypeCreateController'),
})
const ViewMasterCoilTypeView = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/coilType/coilTypeViewController'),
})

const ViewMasterCoilTypeUpdate = LoadableRoute({
    loader: () => import('../components/features/masterData/controllers/coilType/coilTypeUpdateController'),
})

// const ViewManageHome = LoadableRoute({
//     loader: () => import('../components/features/manage/views/viewManageHome'),
// })


const ViewManageSystemList = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/system/systemListController'),
})
const ViewManageSystemCreate = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/system/systemCreateController'),
})
const ViewManageSystemView = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/system/systemViewController'),
})

const ViewManageSystemUpdate = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/system/systemUpdateController'),
})

const ViewManageGroupList = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/group/groupListController'),
})
const ViewManageGroupCreate = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/group/groupCreateController'),
})
const ViewManageGroupView = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/group/groupViewController'),
})

const ViewManageGroupUpdate = LoadableRoute({
    loader: () => import('../components/features/manage/controllers/group/groupUpdateController'),
})

const UserListController = LoadableRoute({
    loader: () => import('../components/features/user/controllers/userListController'),
})

const UserManageNpiController = LoadableRoute({
    loader: () => import('../components/features/user/controllers/userNpiAdminComtroller'),
})
const UserManageAdminController = LoadableRoute({
    loader: () => import('../components/features/user/controllers/userAdminComtroller'),
})


// const ReportController = LoadableRoute({
//     loader: () => import('../components/features/user/controllers/userAdminComtroller'),
// })

const NpiReportController = LoadableRoute({
    loader: () => import('../components/features/report/controllers/npiReportController'),
})

const OverviewController = LoadableRoute({
    loader: () => import('../components/features/report/controllers/overviewController'),
})

const ReportViewDrawingController = LoadableRoute({
    loader: () => import('../components/features/report/viewDrawing/controllers/reportViewDrawingController'),
})


// New System 2022_02_15
// const ViewTubeInTubeListOrder = LoadableRoute({
//     loader: () => import('../components/features/mockup/controllers/renderMockupController'),
// })

const ListTubeInTubeControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/tubeInTube/list/controllers/listTubeInTubeControllers'),
})
const CreateTubeInTubeControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/tubeInTube/create/controllers/createTubeInTubeControllers'),
})
const ViewTubeInTubeControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/tubeInTube/view/controllers/viewReqTubeInTubeController'),
})
const UpdateTubeInTubeControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/tubeInTube/update/controllers/updateTubeInTubeControllers'),
})

const ListDrawingTubeInTubeControllers = LoadableRoute({
    loader: () => import('../components/features/items/tubeInTube/list/controllers/listDrawingTubeInTubeControllers'),
})

const ViewDrawingTubeInTubeControllers = LoadableRoute({
    loader: () => import('../components/features/items/tubeInTube/view/controllers/viewDrawingTubeInTubeControllers'),
})

const ListDrawingAccessoryControllers = LoadableRoute({
    loader: () => import('../components/features/items/accessory/list/controllers/listDrawingAccessoryControllers'),
})

const ViewDrawingAccessoryControllers = LoadableRoute({
    loader: () => import('../components/features/items/accessory/view/controllers/viewDrawingAccessoryControllers'),
})

const ListAccessoryControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/accessory/list/controllers/listAccessoryControllers'),
})

const ListDownloadPdfControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/downloadpdf/infoDownloadPdfController'),
})

const CreateAccessoryControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/accessory/create/controllers/createAccessoryControllers'),
})

const UpdateAccessoryControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/accessory/update/controllers/updateAccessoryControllers'),
})

const ViewAccessoryControllers = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/accessory/view/controllers/viewReqAccessoryController'),
})

const SearchOneDriveController = LoadableRoute({
    loader: () => import('../components/features/oneDrive/controller/oneDriveListController'),
})



const MainPageReqDrawing = LoadableRoute({
    loader: () => import('../components/features/reqDrawing/views/mainPageReqDraw')
})

const MainPageDrawingSystem = LoadableRoute({
    loader: () => import('../components/features/items/views/mainPageDrawingSystem')
})

export default () => (
    <Switch>
        {/* //////  5  /////////// */}
        <PrivateRoute path='/requestDrawing/tubeInTube/update/:active/:id' component={UpdateTubeInTubeControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/tubeInTube/view/:active/:id' component={ViewTubeInTubeControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/coil/update/:active/:id' component={UpdateSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/coil/view/:active/:id' component={ViewSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/accessory/view/:active/:id' component={ViewAccessoryControllers} layout={LayoutMaster} />
        {/* //////  4  /////////// */}
        {/* <AdminPrivateRoute path='/master/coating/view/:id' component={ViewMasterCoatingView} layout={LayoutMaster} /> */}
        <AdminPrivateRoute path='/master/coating/update/:id' component={ViewMasterCoatingUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/finedge/view/:id' component={ViewMasterFinEdgeView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finedge/update/:id' component={ViewMasterFinEdgeUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/finmaterial/view/:id' component={ViewMasterFinMaterialView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finmaterial/update/:id' component={ViewMasterFinMaterialUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/finsurface/view/:id' component={ViewMasterFinSurfaceView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finsurface/update/:id' component={ViewMasterFinSurfaceUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/tubesize/view/:id' component={ViewMasterTubeSizeView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubesize/update/:id' component={ViewMasterTubeSizeUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/insideshape/view/:id' component={ViewMasterInsideShapeView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/insideshape/update/:id' component={ViewMasterInsideShapeUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/tubematerial/view/:id' component={ViewMasterTubeMaterialView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubematerial/update/:id' component={ViewMasterTubeMaterialUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/platematerial/view/:id' component={ViewMasterPlateMaterialView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/platematerial/update/:id' component={ViewMasterPlateMaterialUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/tubepattern/view/:id' component={ViewMasterTubePatternView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubepattern/update/:id' component={ViewMasterTubePatternUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/tubesizeandpattern/view/:id' component={ViewMasterTubeSizeAndPatternView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubesizeandpattern/update/:id' component={ViewMasterTubeSizeAndPatternUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/productgroup/view/:id' component={ViewMasterProductGroupView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/productgroup/update/:id' component={ViewMasterProductGroupUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/paintlocation/view/:id' component={ViewMasterPaintLocationView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/paintlocation/update/:id' component={ViewMasterPaintLocationUpdate} layout={LayoutMaster} />

        <AdminPrivateRoute path='/master/coiltype/view/:id' component={ViewMasterCoilTypeView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/coiltype/update/:id' component={ViewMasterCoilTypeUpdate} layout={LayoutMaster} />

        {/* <PrivateRoute path='/requestDrawing/accessory/create' component={CreateAccessoryControllers} layout={LayoutMaster} /> */}
        <PrivateRoute path='/requestDrawing/accessory/update/:id' component={UpdateAccessoryControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/accessory/view/:id' component={ViewAccessoryControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/tubeInTube/update/:id' component={UpdateTubeInTubeControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/tubeInTube/view/:id' component={ViewTubeInTubeControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/coil/view/:id' component={ViewSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/coil/update/:id' component={UpdateSellOrderController} layout={LayoutMaster} />

        <AdminPrivateRoute path='/manage/group/view/:id' component={ViewManageGroupView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/manage/group/update/:id' component={ViewManageGroupUpdate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/manage/system/view/:id' component={ViewManageSystemView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/manage/system/update/:id' component={ViewManageSystemUpdate} layout={LayoutMaster} />

        <NPIPrivateRoute path='/items/tubeInTube/view/:id' component={ViewDrawingTubeInTubeControllers} layout={LayoutMaster} />
        <NPIPrivateRoute path='/items/accessory/view/:id' component={ViewDrawingAccessoryControllers} layout={LayoutMaster} />

        {/* /////////   3 //////// */}
        <NPIPrivateRoute path='/drawing/view/:drawingId' component={ViewDrawingController} layout={LayoutMaster} />
        <NPIPrivateRoute path='/drawing/update/:drawingId' component={CreateReportController} layout={LayoutMaster} />

        <NPIPrivateRoute path='/item/view/:drawingId' component={ViewItem2Controller} layout={LayoutMaster} />
        <NPIPrivateRoute path='/item/update/:drawingId' component={CreateItem2Controller} layout={LayoutMaster} />


        <AdminPrivateRoute path='/master/coating/create' component={ViewMasterCoatingCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finedge/create' component={ViewMasterFinEdgeCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finmaterial/create' component={ViewMasterFinMaterialCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finsurface/create' component={ViewMasterFinSurfaceCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubesize/create' component={ViewMasterTubeSizeCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/insideshape/create' component={ViewMasterInsideShapeCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubematerial/create' component={ViewMasterTubeMaterialCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/platematerial/create' component={ViewMasterPlateMaterialCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubepattern/create' component={ViewMasterTubePatternCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubesizeandpattern/create' component={ViewMasterTubeSizeAndPatternCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/productgroup/create' component={ViewMasterProductGroupCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/paintlocation/create' component={ViewMasterPaintLocationCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/coiltype/create' component={ViewMasterCoilTypeCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/manage/group/create' component={ViewManageGroupCreate} layout={LayoutMaster} />
        <AdminPrivateRoute path='/manage/system/create' component={ViewManageSystemCreate} layout={LayoutMaster} />
        {/* <PrivateRoute path='/requestDrawing/tubeInTube/view/:id' component={CreateTubeInTubeControllers} layout={LayoutMaster} /> */}
        <PrivateRoute path='/requestDrawing/accessory/create' component={CreateAccessoryControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/tubeInTube/create' component={CreateTubeInTubeControllers} layout={LayoutMaster} />

        <AdminPrivateRoute path='/requestDrawing/restatus' component={ReStatusReqDrawingController} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/coil/create' component={CreateSellOrderController} layout={LayoutMaster} />

        <PrivateRoute path='/viewRequestDrawing/coil/update/:active/:id' component={ViewReqUpdateSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/viewRequestDrawing/coil/update/:id' component={ViewReqUpdateSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/viewRequestDrawing/coil/view/:active/:id' component={ViewReqViewSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/viewRequestDrawing/coil/view/:id' component={ViewReqViewSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/viewRequestDrawing/coil/create' component={ViewReqCreateSellOrderController} layout={LayoutMaster} />
        <PrivateRoute path='/viewRequestDrawing/coil' component={ViewReqSearchSellOrderController} layout={LayoutMaster} />

        {/* /////////  2 //////// */}
        <PrivateRoute path='/requestDrawing/downloadpdf' component={ListDownloadPdfControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/accessory' component={ListAccessoryControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/tubeInTube' component={ListTubeInTubeControllers} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing/coil' component={SearchSellOrderController} layout={LayoutMaster} />

        <PrivateRoute path='/report/npi' component={NpiReportController} layout={LayoutMaster} />
        <PrivateRoute path='/report/requestDrawing' component={OverviewSellOrderControler} layout={LayoutMaster} />
        <PrivateRoute path='/report/viewDrawing' component={ReportViewDrawingController} layout={LayoutMaster} />

        <NPIPrivateRoute path='/create/drawing' component={CreateDrawingController} layout={LayoutMaster} />
        <NPIPrivateRoute path='/create/item' component={CreateItemsController} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/coating' component={ViewMasterCoatingList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finedge' component={ViewMasterFinEdgeList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finmaterial' component={ViewMasterFinMaterialList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/finsurface' component={ViewMasterFinSurfaceList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubesize' component={ViewMasterTubeSizeList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/insideshape' component={ViewMasterInsideShapeList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubematerial' component={ViewMasterTubeMaterialList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/platematerial' component={ViewMasterPlateMaterialList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubepattern' component={ViewMasterTubePatternList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/tubesizeandpattern' component={ViewMasterTubeSizeAndPatternList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/productgroup' component={ViewMasterProductGroupList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/paintlocation' component={ViewMasterPaintLocationList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master/coiltype' component={ViewMasterCoilTypeList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/manage/group' component={ViewManageGroupList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/manage/system' component={ViewManageSystemList} layout={LayoutMaster} />
        <AdminPrivateRoute path='/user/manageadmin' component={UserManageAdminController} layout={LayoutMaster} />
        <AdminPrivateRoute path='/user/managenpi' component={UserManageNpiController} layout={LayoutMaster} />
        <AdminPrivateRoute path='/settings/system' component={ViewSystemInfoSetting} layout={LayoutMaster} />

        <NPIPrivateRoute path='/items/accessory' component={ListDrawingAccessoryControllers} layout={LayoutMaster} />
        <NPIPrivateRoute path='/items/tubeInTube' component={ListDrawingTubeInTubeControllers} layout={LayoutMaster} />
        <NPIPrivateRoute path='/items/coil' component={SearchDrawingController} layout={LayoutMaster} />



        {/* /////////  1  //////// */}
        {/* <PublicRoute path='/mockup' component={ViewTubeInTubeListOrder} layout={LayoutMaster} /> */}
        {/* <NPIPrivateRoute path='/drawing' component={SearchDrawingController} layout={LayoutMaster} /> */}

        <PrivateRoute path='/searchOneDrive' component={SearchOneDriveController} layout={LayoutMaster} />
        <PrivateRoute path='/report' component={OverviewController} layout={LayoutMaster} />
        <NPIPrivateRoute path='/itemsmenu' component={MainPageDrawingSystem} layout={LayoutMaster} />
        <PrivateRoute path='/export' component={ExportReportController} layout={LayoutMaster} />
        <AdminPrivateRoute path='/master' component={ViewMasterHome} layout={LayoutMaster} />
        <PrivateRoute path='/requestDrawing' component={MainPageReqDrawing} layout={LayoutMaster} />
        <PrivateRoute path='/info' component={SystenInfoView} layout={LayoutMaster} />
        <AdminPrivateRoute path='/users' component={UserListController} layout={LayoutMaster} />
        <AdminPrivateRoute path='/settings' component={ViewSetting} layout={LayoutMaster} />

        <PrivateRoute exact path='/' component={HomeController} layout={LayoutMaster} />

        <PublicRoute path='/login' component={Login} layout={LayoutBlank} />
        <PublicRoute path='/unauthen' component={UnAuthenController} layout={LayoutMaster} />
        <PublicRoute component={NotFoundController} layout={LayoutMaster} />






        {/* <PrivateRoute path='/masterdata/coating/:coatingId' component={CreateCoatingController} layout={LayoutMaster} /> */}

    </Switch>
)



// WEBPACK FOOTER //
// ./src/app/routes/Routes.js